import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { OSGroup, OSGroupSearchParam } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OSGroupService {

  private path = '/os_groups';

  constructor(private http: AlloxApiService) { }

  public search(param?: OSGroupSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new OSGroup(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new OSGroup(obj))
    );
  }

  public post(item: OSGroup) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: OSGroup) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: OSGroup[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
